import React, { useCallback, useEffect, useRef, useState } from 'react'
import MissingPriceModal from './MissingPriceModal'

// The pricing flow only receives an optional async callback; it does not
// depend on this hook or its UI. Both pickers share one instance in the nav.
export const useMissingPriceConfirm = () => {
  const [pending, setPending] = useState(null)
  const resolver = useRef(null)
  const mounted = useRef(false)

  useEffect(() => {
    mounted.current = true
    return () => {
      mounted.current = false
      resolver.current?.(false)
      resolver.current = null
    }
  }, [])

  const resolveRemoval = useCallback(proceed => {
    resolver.current?.(proceed)
    resolver.current = null
    setPending(null)
  }, [])

  const confirmRemovalIn = useCallback(
    warehouseName => products => {
      // A request can finish after navigation has unmounted its caller.
      if (!mounted.current) return Promise.resolve(false)
      resolver.current?.(false)
      return new Promise(resolve => {
        resolver.current = resolve
        setPending({ products, warehouseName })
      })
    },
    []
  )

  return {
    confirmRemovalIn,
    missingPriceModal: (
      <MissingPriceModal pending={pending} onResolve={resolveRemoval} />
    ),
  }
}
